/**
 * Content file for all new commercial/SEO pages.
 * Text is written in Polish, professional but accessible tone.
 * Placeholder data is marked so it can be replaced with real content later.
 */

export const companyInfo = {
  // Brand name (wyświetlany jako marka)
  name: 'WebNaTak',
  // Pełna nazwa prawna (używana w fakturach, regulaminie, polityce prywatności)
  legalName: 'Ihor Bereteli IT Solutions',
  nip: '5272890051',
  regon: '541675408',
  email: 'kontakt@webnatak.pl',
  phone: '+48 573 195 600',
  phoneDigits: '+48573195600',
  street: 'ul. Konopnickiej 13 U3',
  postalCode: '58-100',
  city: 'Świdnica',
  country: 'Polska',
  countryCode: 'PL',
  region: 'dolnośląskie',
  workingHours: 'Pon-Pt 9:00-17:00, Sob 10:00-14:00',
  mapQuery: 'ul.+Konopnickiej+13+U3,+58-100+Świdnica',
  mapEmbed:
    'https://www.google.com/maps?q=ul.+Konopnickiej+13+U3,+58-100+%C5%9Awidnica&output=embed',
};

// --- Segmenty klientów (Dla kogo) ---
export const audienceSegments = [
  {
    slug: 'lokalne-firmy-uslugowe',
    icon: 'Briefcase',
    title: 'Lokalne firmy usługowe',
    description:
      'Hydraulicy, elektrycy, serwisy, usługi domowe - strona, która pokazuje zakres prac i zdobywa telefony.',
    link: '/strony-internetowe-swidnica',
  },
  {
    slug: 'salon-kosmetyczny',
    icon: 'Sparkles',
    title: 'Salony kosmetyczne i fryzjerskie',
    description:
      'Galeria zabiegów, cennik, godziny otwarcia i prosty formularz rezerwacji - wszystko pod ręką klientki.',
    link: '/strona-dla-salonu-kosmetycznego',
  },
  {
    slug: 'gabinet-lekarski',
    icon: 'Stethoscope',
    title: 'Gabinety lekarskie i stomatologiczne',
    description:
      'Specjalizacje, zespół, informacje praktyczne i rejestracja - strona pisana zrozumiałym językiem pacjenta.',
    link: '/strona-dla-lekarza',
  },
  {
    slug: 'restauracja',
    icon: 'UtensilsCrossed',
    title: 'Restauracje i kawiarnie',
    description:
      'Menu, zdjęcia, dane adresowe z mapą i numerem telefonu - to, czego goście szukają w pierwszej kolejności.',
    link: '/strona-dla-restauracji',
  },
  {
    slug: 'firma-budowlana',
    icon: 'HardHat',
    title: 'Firmy budowlane i remontowe',
    description:
      'Portfolio realizacji, zakres usług i opinie - strona, która przekonuje, że wasza ekipa zna się na robocie.',
    link: '/strona-dla-firmy-budowlanej',
  },
  {
    slug: 'fotograf',
    icon: 'Camera',
    title: 'Fotografowie i freelancerzy',
    description:
      'Portfolio zdjęć, pakiety, terminarz i formularz zapytania - wizytówka, która broni się sama.',
    link: '/strona-dla-fotografa',
  },
  {
    slug: 'prawnik',
    icon: 'Scale',
    title: 'Prawnicy i doradcy',
    description:
      'Specjalizacje, doświadczenie, artykuły, kontakt - strona, która buduje autorytet i zaufanie.',
    link: '/strona-dla-prawnika',
  },
];

// --- Co dokładnie dostajesz ---
export const includedChecklist = [
  'Indywidualny projekt graficzny lub szablon premium dopasowany do Twojej branży',
  'Responsywna wersja mobilna - wygląda dobrze na telefonie, tablecie i komputerze',
  'Formularz kontaktowy z wysyłką na Twój e-mail',
  'Hosting na szybkim serwerze w Polsce',
  'Certyfikat SSL (https://) - bezpieczne połączenie i lepsza pozycja w Google',
  'Regularne aktualizacje silnika i kopie zapasowe',
  'Wsparcie techniczne w godzinach pracy',
  'Podłączenie Google Analytics i Google Maps',
  'Podstawowa optymalizacja SEO (meta tagi, szybkość, struktura nagłówków)',
  'Integracja z mediami społecznościowymi',
  'Do kilku drobnych poprawek miesięcznie w cenie (zależnie od pakietu)',
];

// --- Jak to działa - 4 kroki (rozszerzone) ---
export const processStepsNew = [
  {
    number: '01',
    icon: 'MessageSquare',
    title: 'Krótka rozmowa',
    short: 'Poznajemy Twoją firmę i potrzeby.',
    description:
      'Zaczynamy od 15–20 minutowej rozmowy - telefonicznie lub online. Pytamy o Twoją firmę, klientów, konkurencję i to, co strona ma dla Ciebie robić. Bez ciśnienia i bez sprzedaży na siłę - często już po tej rozmowie wiesz, czy chcesz z nami pracować.',
  },
  {
    number: '02',
    icon: 'Palette',
    title: 'Projekt',
    short: 'Przygotowujemy propozycję graficzną.',
    description:
      'W ciągu kilku dni dostajesz od nas propozycję układu i wyglądu strony - dopasowaną do Twojej branży, logo i kolorów. Widzisz dokładnie, jak będzie wyglądać strona główna, zanim cokolwiek zapłacisz.',
  },
  {
    number: '03',
    icon: 'PenTool',
    title: 'Poprawki i akceptacja',
    short: 'Dopasowujemy szczegóły.',
    description:
      'Zbieramy Twoje uwagi, wprowadzamy zmiany, pokazujemy kolejną wersję. Tyle iteracji, ile potrzeba, żebyś był zadowolony z efektu. Dopiero po Twojej akceptacji ruszamy z publikacją.',
  },
  {
    number: '04',
    icon: 'Rocket',
    title: 'Publikacja i opieka',
    short: 'Twoja strona działa, my się nią zajmujemy.',
    description:
      'Publikujemy stronę na naszym hostingu, podłączamy SSL, Google Analytics i Mapy. Od tej chwili Twoja strona działa, a my zajmujemy się jej aktualizacjami, backupami i drobnymi poprawkami - w ramach miesięcznego abonamentu.',
  },
];

// --- Dlaczego abonament ---
export const abonamentReasons = [
  {
    icon: 'Wallet',
    title: 'Brak dużej inwestycji na start',
    description:
      'Nie musisz jednorazowo wydawać 3–8 tysięcy złotych. Zaczynasz od miesięcznej płatności - tak samo jak za telefon czy księgowość.',
  },
  {
    icon: 'RefreshCw',
    title: 'Strona zawsze aktualna',
    description:
      'Silnik, wtyczki i zabezpieczenia są aktualizowane na bieżąco. Nie budzisz się pewnego dnia ze stroną, która „przestała działać” po dwóch latach.',
  },
  {
    icon: 'Package',
    title: 'Wszystko w jednym miejscu',
    description:
      'Nie musisz osobno szukać hostingu, certyfikatu SSL, osoby do poprawek i kogoś od SEO. Masz jeden kontakt i jeden rachunek.',
  },
  {
    icon: 'LogOut',
    title: 'Rezygnacja w każdej chwili',
    description:
      'Po zakończeniu minimalnego okresu umowy możesz zrezygnować w każdej chwili z miesięcznym wypowiedzeniem. Bez kar i bez ukrytych kosztów.',
  },
  {
    icon: 'Key',
    title: 'Możliwość wykupu',
    description:
      'Jeśli w pewnym momencie chcesz przenieść stronę na własność - ustalamy kwotę wykupu i przekazujemy pliki oraz dostępy. Strona zostaje Twoja.',
  },
];

// --- Portfolio (prawdziwe realizacje) ---
export const portfolioItems = [
  {
    slug: 'orun-szkola-capoeiry',
    title: 'Szkoła Capoeiry ORUN',
    url: 'https://orun.pl',
    industry: 'Sport / Szkoła',
    location: 'Świdnica i Dzierżoniów',
    description:
      'Strona internetowa dla szkoły capoeiry ORUN działającej w Świdnicy i Dzierżoniowie. Responsywny design, harmonogram zajęć, galeria zdjęć i formularz kontaktowy. Strona pomaga szkole pozyskiwać nowych uczestników z wyszukiwarki Google.',
    image: '/images/portfolio/orun-pl.png',
    imageAlt: 'Zrzut ekranu strony orun.pl - Szkoła Capoeiry ORUN',
    features: [
      'Responsywny design (desktop, tablet, mobile)',
      'Harmonogram zajęć z podziałem na lokalizacje',
      'Galeria zdjęć z treningów i występów',
      'Formularz zapisu i kontaktu',
      'Lokalne SEO (Świdnica, Dzierżoniów)',
      'Integracja z Google Maps',
    ],
    placeholder: false,
  },
  {
    slug: 'calqool-saas',
    title: 'Calqool - kalkulatory online',
    url: 'https://calqool.com',
    industry: 'SaaS / Narzędzia',
    location: 'Międzynarodowy',
    description:
      'Platforma z kalkulatorami online dla biznesu i użytkowników prywatnych. Dziesiątki gotowych narzędzi (finanse, zdrowie, konwersje, budownictwo), szybkie ładowanie, wersje językowe, SEO-friendly struktura katalogu.',
    image: '/images/portfolio/calqool-com.png',
    imageAlt: 'Zrzut ekranu strony calqool.com - kalkulatory online',
    features: [
      'Katalog dziesiątek kalkulatorów tematycznych',
      'Wysokowydajny frontend (Core Web Vitals w zieleni)',
      'Strategia SEO pod długi ogon zapytań',
      'Wersje wielojęzyczne',
      'Monetyzacja przez AdSense / partnerów',
      'Skalowalna architektura pod tysiące podstron',
    ],
    placeholder: false,
  },
  {
    slug: 'polskipisarz-ai-copywriter',
    title: 'PolskiPisarz - AI copywriter',
    url: 'https://polskipisarz.pl',
    industry: 'SaaS / Technologia',
    location: 'Polska (cały kraj)',
    description:
      'Aplikacja webowa PolskiPisarz - generator profesjonalnych tekstów po polsku z wykorzystaniem sztucznej inteligencji. CV, opisy na Allegro, umowy, posty, emaile biznesowe. System kont użytkowników, panel generacji, płatności online.',
    image: '/images/portfolio/polskipisarz-pl.png',
    imageAlt: 'Zrzut ekranu aplikacji polskipisarz.pl - generator tekstów AI',
    features: [
      'System logowania i rejestracji użytkowników',
      'Panel generacji tekstów z zapisem historii',
      'Integracja z modelami AI (generowanie tekstu po polsku)',
      'Płatności online (Stripe)',
      'Blog z artykułami o copywritingu',
      'SEO i indeksowanie w Google',
    ],
    placeholder: false,
  },
  {
    slug: 'melvari-ecommerce',
    title: 'Melvari - butik online',
    url: 'https://melvari.eu',
    industry: 'E-commerce / Moda',
    location: 'Europa',
    description:
      'Sklep internetowy Melvari - starannie dobrany asortyment z naciskiem na estetykę prezentacji produktów. Czyste UI, szybki checkout, integracje płatności i wysyłek dla rynku europejskiego.',
    image: '/images/portfolio/melvari-eu.png',
    imageAlt: 'Zrzut ekranu sklepu melvari.eu - butik online',
    features: [
      'Nowoczesne, minimalistyczne UI produktowe',
      'Responsywny katalog z filtrami',
      'Integracja płatności i wysyłek międzynarodowych',
      'Zoptymalizowane zdjęcia i lazy loading',
      'Newsletter i retargeting',
      'Analityka e-commerce (GA4)',
    ],
    placeholder: false,
  },
  {
    slug: 'chilipiri-agregator-promocji',
    title: 'Chilipiri - agregator promocji i zniżek',
    url: 'https://chilipiri.ro',
    industry: 'Agregator / Porównywarka',
    location: 'Rumunia',
    description:
      'Portal agregujący aktualne promocje, kupony i zniżki ze sklepów w Rumunii. Użytkownicy przeglądają oferty według kategorii, sortują po popularności i "temperaturze" okazji, zgłaszają własne znaleziska. System głosowania, komentarzy i wyszukiwania.',
    image: '/images/portfolio/chilipiri-ro.png',
    imageAlt: 'Zrzut ekranu strony chilipiri.ro - agregator promocji i zniżek',
    features: [
      'Katalog promocji z kategoriami i tagami',
      'Sortowanie po popularności i "temperaturze" okazji',
      'System głosowania i komentarzy użytkowników',
      'Zgłaszanie nowych ofert przez społeczność',
      'Wyszukiwarka pełnotekstowa',
      'Powiadomienia o nowych okazjach',
    ],
    placeholder: false,
  },
];

// --- Opinie (placeholders) ---
export const testimonials = [
  {
    quote:
      'Strona działa od pierwszego dnia i sama się aktualizuje. Nie muszę nic robić - dostaję telefony, bo ludzie mnie w końcu znajdują w Google.',
    name: 'Marta K.',
    company: 'Salon urody „Promyk”',
    industry: 'Salon kosmetyczny',
    placeholder: true,
  },
  {
    quote:
      'Najbardziej podoba mi się, że nie musiałem płacić 5 tysięcy na start. Płacę miesiąc w miesiąc, a strona wygląda jak u dużych firm.',
    name: 'Paweł M.',
    company: 'Usługi elektryczne',
    industry: 'Firma usługowa',
    placeholder: true,
  },
  {
    quote:
      'Poprawki robione są szybko. Napisałem mailem o zmianę godzin otwarcia w święta - było zrobione tego samego dnia.',
    name: 'Joanna W.',
    company: 'Restauracja „Pod Lipą”',
    industry: 'Restauracja',
    placeholder: true,
  },
  {
    quote:
      'Przed WebNaTak miałem stronę, której nie umiałem sam zaktualizować. Tu w końcu ktoś zajmuje się tym za mnie i mam spokój.',
    name: 'Tomasz R.',
    company: 'Budownictwo Kowalski',
    industry: 'Firma budowlana',
    placeholder: true,
  },
  {
    quote:
      'Profesjonalna rozmowa, konkretne propozycje, bez naciągania na rzeczy, których nie potrzebowałem. Polecam małym firmom.',
    name: 'Katarzyna L.',
    company: 'Gabinet „Zdrowy Uśmiech”',
    industry: 'Stomatologia',
    placeholder: true,
  },
  {
    quote:
      'Strona miała być „prosta i działająca” - i taka jest. Klienci dzwonią, zdjęcia są dobrze wyeksponowane, nic się nie sypie.',
    name: 'Anna N.',
    company: 'Anna Nowak Fotografia',
    industry: 'Fotograf',
    placeholder: true,
  },
];

// --- FAQ - pełna lista, grupowana ---
export const faqGroups = [
  {
    title: 'O usłudze',
    questions: [
      {
        q: 'Ile kosztuje strona internetowa?',
        a: 'W naszym modelu abonamentowym nie płacisz nic na start. Strony zaczynają się od 199 zł miesięcznie (pakiet Start) i obejmują projekt, wdrożenie, hosting, SSL, wsparcie i drobne poprawki. Pełne porównanie pakietów znajdziesz na stronie cennika.',
      },
      {
        q: 'Jak długo trwa realizacja?',
        a: 'Standardowo strona jest gotowa w około 7 dni roboczych od momentu, w którym ustalimy zakres i dostaniemy od Ciebie teksty oraz zdjęcia. Bardziej rozbudowane projekty (wielojęzyczne, z integracjami) mogą zająć 10–14 dni.',
      },
      {
        q: 'Czy pomagacie z treściami na stronę?',
        a: 'Tak. Mamy gotowe szablony tekstów dla każdej branży, które dopasowujemy do Twojej firmy. Jeśli chcesz - możemy napisać całe teksty od zera na podstawie rozmowy z Tobą. To usługa dodatkowa, wyceniana indywidualnie.',
      },
    ],
  },
  {
    title: 'O cenie i rozliczeniach',
    questions: [
      {
        q: 'Czy są jakieś ukryte koszty?',
        a: 'Nie. W miesięcznej kwocie masz wszystko: projekt, wdrożenie, hosting, SSL, aktualizacje, kopie zapasowe, wsparcie i ustaloną liczbę drobnych poprawek. Dodatkowe rzeczy (nowe sekcje, integracje, osobne kampanie) wyceniamy z góry i zawsze się zgadzasz przed pracą.',
      },
      {
        q: 'Czy w cenie jest pozycjonowanie SEO?',
        a: 'W cenie znajduje się podstawowa optymalizacja SEO - tytuły, opisy, struktura nagłówków, szybkość, sitemap, robots.txt, schema.org. To fundament, który sprawia, że strona może być dobrze indeksowana w Google. Aktywne pozycjonowanie (link building, regularne artykuły, kampanie) to osobna usługa.',
      },
      {
        q: 'Ile poprawek mogę zlecić w miesiącu?',
        a: 'W pakiecie Start jest 1 drobna poprawka miesięcznie, w Pro - do 3, w Biznes+ - do 6. „Drobna poprawka” to np. zmiana tekstu, podmiana zdjęcia, dodanie informacji. Większe zmiany (nowa sekcja, nowa podstrona) wyceniamy osobno.',
      },
      {
        q: 'Kiedy płacę pierwszą fakturę?',
        a: 'Pierwszą fakturę wystawiamy po publikacji strony, czyli po około tygodniu od startu prac. Do tego momentu nic nie płacisz.',
      },
    ],
  },
  {
    title: 'O procesie',
    questions: [
      {
        q: 'Jak wygląda pierwsza rozmowa?',
        a: 'Dzwonimy lub piszemy mailem w ustalonym terminie. Pytamy o Twoją firmę, klientów, konkurencję i czego oczekujesz od strony. Rozmowa trwa 15–20 minut i jest bezpłatna - nawet jeśli ostatecznie nie zdecydujesz się na współpracę.',
      },
      {
        q: 'Co muszę przygotować?',
        a: 'Najlepiej: logo (jeśli masz), zdjęcia (firmy, zespołu, realizacji), krótki opis co robisz i dla kogo. Jeśli czegoś brakuje - doradzimy, jak to uzupełnić, albo wykorzystamy zdjęcia stockowe.',
      },
      {
        q: 'Czy mogę coś zmienić w projekcie w trakcie?',
        a: 'Tak. W fazie projektu zbieramy Twoje uwagi i wprowadzamy zmiany, aż będziesz zadowolony. Dopiero po Twojej akceptacji ruszamy z publikacją.',
      },
    ],
  },
  {
    title: 'O technikaliach',
    questions: [
      {
        q: 'Kto jest właścicielem strony?',
        a: 'W trakcie trwania abonamentu strona jest utrzymywana na naszej infrastrukturze. Treści (teksty, zdjęcia, Twoje logo) pozostają Twoją własnością. W każdej chwili możesz wykupić stronę na własność - wtedy przekazujemy pliki i dostępy.',
      },
      {
        q: 'Czy strona jest mobilna?',
        a: 'Tak, każda strona, którą robimy, działa na telefonach, tabletach i komputerach. To już dzisiaj standard i wymóg Google - nie robimy stron tylko „na komputer”.',
      },
      {
        q: 'Czy strona będzie szybka?',
        a: 'Tak. Dbamy o optymalizację grafik (WebP, lazy loading), cache, minifikację kodu i szybki hosting. Strona powinna ładować się w mniej niż 3 sekundy na dobrym łączu.',
      },
      {
        q: 'Czy podłączycie własną domenę?',
        a: 'Tak. Jeśli masz już domenę - podłączamy ją do strony (zmieniamy rekordy DNS). Jeśli nie masz - pomagamy ją kupić i skonfigurować.',
      },
    ],
  },
  {
    title: 'O rezygnacji i własności',
    questions: [
      {
        q: 'Co się stanie, jeśli zrezygnuję?',
        a: 'Po zakończeniu umowy wyłączamy stronę z naszego hostingu. Treści i zdjęcia, które dostarczyłeś, możesz zabrać ze sobą. Jeśli chcesz zachować stronę i przenieść ją gdzie indziej - oferujemy wykup na własność.',
      },
      {
        q: 'Czy mogę wykupić stronę na własność?',
        a: 'Tak. Ustalamy kwotę wykupu (zależną od pakietu i zakresu strony), po zapłacie przekazujemy pliki, kod i dostępy. Strona przestaje być w naszym abonamencie i staje się w pełni Twoja.',
      },
      {
        q: 'Czy mogę zrezygnować w każdej chwili?',
        a: 'Po zakończeniu minimalnego okresu umowy (12 miesięcy) możesz zrezygnować w każdej chwili z miesięcznym wypowiedzeniem. W okresie wypowiedzenia strona działa normalnie.',
      },
    ],
  },
];

// Skrócone FAQ na stronie głównej (8 pytań)
export const homeFAQ = [
  faqGroups[0].questions[0], // ile kosztuje
  faqGroups[0].questions[1], // jak długo trwa
  faqGroups[3].questions[0], // kto jest właścicielem
  faqGroups[4].questions[0], // co się stanie jeśli zrezygnuję
  faqGroups[4].questions[1], // wykup
  faqGroups[1].questions[2], // ile poprawek
  faqGroups[1].questions[1], // SEO
  faqGroups[0].questions[2], // treści
];

// --- Cennik, co NIE jest wliczone ---
export const notIncludedInPrice = [
  'Pisanie tekstów copywriterskich od zera (dostępne jako usługa dodatkowa)',
  'Aktywne pozycjonowanie SEO (link building, regularne artykuły, kampanie)',
  'Dedykowane funkcjonalności wymagające programowania (kalkulatory, panele klienta)',
  'Pełny sklep internetowy z płatnościami i magazynem (osobna oferta)',
  'Profesjonalna sesja zdjęciowa (polecamy lokalnego fotografa)',
  'Kampanie Google Ads i Facebook Ads (obsługujemy osobno)',
];

export const pricingFAQ = [
  {
    q: 'Dlaczego abonament, a nie jedna opłata?',
    a: 'Bo strona to nie produkt „raz kupiony”. Co miesiąc wychodzą aktualizacje silnika, wtyczek, zabezpieczeń. Ktoś musi zadbać o kopie zapasowe, hosting, certyfikat SSL, drobne poprawki. W modelu jednorazowym albo płacisz za to osobno, albo strona powoli umiera. Abonament łączy wszystko w jedną, przewidywalną kwotę.',
  },
  {
    q: 'Jaka jest minimalna długość umowy?',
    a: 'Umowa zawierana jest na minimum 12 miesięcy. Po tym okresie przechodzi w tryb comiesięczny z wypowiedzeniem 1-miesięcznym.',
  },
  {
    q: 'Czy ceny są brutto czy netto?',
    a: 'Ceny w cenniku są cenami netto. Do każdej doliczamy standardowy VAT 23%. Dla firm VAT jest kosztem odliczalnym.',
  },
  {
    q: 'Czy można zmienić pakiet w trakcie trwania umowy?',
    a: 'Tak - w każdej chwili możesz przejść na wyższy pakiet. Zmiana na niższy możliwa jest od kolejnego okresu rozliczeniowego.',
  },
  {
    q: 'Co jeśli potrzebuję czegoś, czego nie ma w żadnym pakiecie?',
    a: 'Opisz nam swoją potrzebę - przygotujemy indywidualną wycenę i dodamy element do Twojego abonamentu albo jako jednorazowy projekt.',
  },
];

// --- Porównanie abonament vs jednorazowy projekt ---
export const modelComparison = [
  {
    feature: 'Koszt na start',
    abonament: 'Brak - 0 zł',
    jednorazowy: '3 000 – 8 000 zł i więcej',
  },
  { feature: 'Hosting', abonament: 'W cenie', jednorazowy: 'Osobna umowa, 200–600 zł/rok' },
  { feature: 'Certyfikat SSL', abonament: 'W cenie', jednorazowy: 'Osobno, 0–500 zł/rok' },
  { feature: 'Aktualizacje silnika', abonament: 'W cenie', jednorazowy: 'Płacisz za godziny pracy' },
  {
    feature: 'Kopie zapasowe',
    abonament: 'Automatyczne, w cenie',
    jednorazowy: 'Twoja odpowiedzialność',
  },
  { feature: 'Drobne poprawki', abonament: 'Wliczone w limit', jednorazowy: 'Płatne za godzinę' },
  {
    feature: 'Wsparcie techniczne',
    abonament: 'W godzinach pracy',
    jednorazowy: 'Dodatkowa umowa',
  },
  {
    feature: 'Co po roku',
    abonament: 'Strona dalej działa i jest aktualna',
    jednorazowy: 'Często zaniedbana, podatna na awarie',
  },
];

// --- Opieka nad stroną - zakres ---
export const careServices = [
  'Aktualizacje silnika (WordPress / inne) i wtyczek',
  'Regularne kopie zapasowe z możliwością przywrócenia',
  'Monitoring dostępności i czasu odpowiedzi',
  'Reakcja na awarie i przerwy w działaniu',
  'Podstawowe zabezpieczenia (firewall, ograniczenia logowań)',
  'Certyfikat SSL i jego odnawianie',
  'Drobne poprawki treści i zdjęć w ramach limitu',
  'Wsparcie techniczne e-mailowe i telefoniczne',
  'Audyt SEO i wydajności raz na kwartał',
  'Raportowanie wykonanych działań',
];

// --- Strony branżowe - dane konfiguracyjne ---
export const industryPages = {
  'strona-dla-salonu-kosmetycznego': {
    path: '/strona-dla-salonu-kosmetycznego',
    h1: 'Strona internetowa dla salonu kosmetycznego',
    metaTitle: 'Strona internetowa dla salonu kosmetycznego | WebNaTak',
    metaDescription:
      'Strona dla salonu kosmetycznego w abonamencie - galeria zabiegów, cennik, rezerwacje i lokalne SEO. Bez opłat startowych.',
    intro:
      'Klientki salonów kosmetycznych szukają w internecie trzech rzeczy: zdjęć, cennika i numeru telefonu. Jeśli tego nie znajdą u Ciebie - idą do konkurencji. Dobrze zaprojektowana strona salonu rozwiązuje ten problem i sprawia, że wizyty są rezerwowane szybciej, a Ty spędzasz mniej czasu na odbieraniu powtarzających się pytań.',
    problem:
      'Większość salonów w Polsce nie ma własnej strony albo ma taką, która wygląda źle na telefonie, nie ma aktualnego cennika i straszy grafiką sprzed dekady. Efekt? Klientka wchodzi, zamyka kartę po 2 sekundach i dzwoni do konkurencji.',
    solution:
      'W WebNaTak robimy strony salonów kosmetycznych w czystym, estetycznym stylu - z naciskiem na zdjęcia, cennik i rezerwację. Strona ładuje się szybko, wygląda dobrze na telefonie, a nowe zdjęcia z realizacji dodajemy za Ciebie w ramach abonamentu.',
    features: [
      'Galeria zabiegów z podziałem na kategorie (manicure, paznokcie, kosmetologia, SPA)',
      'Aktualny cennik - prosty do zaktualizowania przez nas jednym mailem',
      'Godziny otwarcia z informacją o dniach specjalnych (święta, wakacje)',
      'Formularz kontaktowy / rezerwacyjny trafiający na Twój e-mail lub WhatsApp',
      'Informacje o zespole - krótkie bio, specjalizacje, zdjęcia',
      'Integracja z Google Maps i Google Moja Firma (widoczność lokalnie)',
      'Link do Instagrama i Facebooka - klientki chcą zobaczyć świeże zdjęcia',
    ],
  },
  'strona-dla-lekarza': {
    path: '/strona-dla-lekarza',
    h1: 'Strona internetowa dla lekarza, gabinetu i stomatologa',
    metaTitle: 'Strona internetowa dla lekarza i gabinetu | WebNaTak',
    metaDescription:
      'Strona dla gabinetu lekarskiego lub stomatologicznego w abonamencie - specjalizacje, zespół, rejestracja. Profesjonalnie i zrozumiale.',
    intro:
      'Pacjent szukający lekarza w internecie chce wiedzieć trzy rzeczy: gdzie, kiedy i ile. Dobrze zaprojektowana strona gabinetu odpowiada na te pytania w pierwszych sekundach, buduje zaufanie i ułatwia rejestrację. My dbamy, żeby była napisana językiem pacjenta - bez nadmiaru medycznego żargonu.',
    problem:
      'Strony gabinetów w Polsce często wyglądają jak dokumenty Word - dużo tekstu, brak zdjęć, brak klarownej rejestracji. Pacjent nie wie, od czego zacząć i rezygnuje.',
    solution:
      'Robimy strony, które wyglądają profesjonalnie, ale przede wszystkim są łatwe w odbiorze. Pacjent od razu widzi: co leczysz, gdzie przyjmujesz, kiedy i jak się umówić. Treści przygotowujemy zgodnie z wymogami branży medycznej (bez pustych obietnic).',
    features: [
      'Lista specjalizacji i zabiegów z krótkimi opisami zrozumiałymi dla pacjenta',
      'Prezentacja zespołu - lekarze, stomatolodzy, higienistki, ich doświadczenie',
      'Informacje praktyczne (dojazd, parking, NFZ vs. prywatnie, pierwsza wizyta)',
      'Kontakt do rejestracji - telefon, formularz, e-mail',
      'Sekcja „Dla pacjenta” - najczęstsze pytania, przygotowanie do wizyty',
      'Strona zgodna z zasadami informowania w branży medycznej',
      'Lokalne SEO (Świdnica, okolice) i mapa dojazdu',
    ],
  },
  'strona-dla-restauracji': {
    path: '/strona-dla-restauracji',
    h1: 'Strona internetowa dla restauracji i kawiarni',
    metaTitle: 'Strona internetowa dla restauracji i kawiarni | WebNaTak',
    metaDescription:
      'Strona dla restauracji w abonamencie - menu, galeria, rezerwacje i mapa. Prosto, szybko, bez opłat na start.',
    intro:
      'Gość wchodzący na stronę restauracji szuka menu, zdjęć i numeru telefonu. Jeśli tego nie znajdzie w 5 sekund - otwiera inną restaurację w tej samej przeglądarce. Strony, które robimy, są zoptymalizowane pod ten konkretny moment decyzji.',
    problem:
      'Wiele restauracji w Polsce ma strony, na których menu jest zdjęciem z telefonu (nieczytelnym na ekranie), nie ma aktualnych godzin, a numer telefonu jest ukryty w stopce.',
    solution:
      'Robimy strony restauracji z czytelnym menu w formie tekstowej (nie zdjęciem), klikalnym numerem telefonu, mapą i formularzem rezerwacji. Strona ładuje się szybko nawet na słabym łączu w centrum miasta.',
    features: [
      'Menu w formie tekstowej z podziałem na kategorie - łatwe do zaktualizowania',
      'Galeria zdjęć dań i wnętrza (wysokiej jakości)',
      'Godziny otwarcia z ostrzeżeniami o dniach specjalnych',
      'Klikalny numer telefonu i mapa Google',
      'Formularz rezerwacji stolika lub link do zewnętrznego systemu',
      'Sekcja wydarzeń (piątkowe koncerty, menu sezonowe)',
      'Linki do Facebooka i Instagrama - bieżące zdjęcia dań',
    ],
  },
  'strona-dla-firmy-budowlanej': {
    path: '/strona-dla-firmy-budowlanej',
    h1: 'Strona internetowa dla firmy budowlanej i remontowej',
    metaTitle: 'Strona internetowa dla firmy budowlanej | WebNaTak',
    metaDescription:
      'Strona dla firmy budowlanej w abonamencie - portfolio realizacji, zakres usług i formularz wyceny. Profesjonalnie, bez opłat startowych.',
    intro:
      'Klient szukający ekipy budowlanej w internecie nie wierzy w reklamy. Wierzy w zdjęcia realizacji i opinie. Dobrze zaprojektowana strona firmy budowlanej powinna pokazać: co umiecie, co już zrobiliście i dlaczego można Wam zaufać.',
    problem:
      'Większość stron firm budowlanych w Polsce wygląda jak szablon z 2012 roku - z dużym logiem, stockowymi zdjęciami robotnika na tle nieba i zerową konkretyką. To nikogo nie przekonuje.',
    solution:
      'Robimy strony firm budowlanych z naciskiem na prawdziwe realizacje (przed/po), precyzyjny zakres usług i jasny formularz zapytania o wycenę. Strona buduje zaufanie od pierwszego ekranu.',
    features: [
      'Portfolio realizacji ze zdjęciami przed/po i krótkim opisem zakresu prac',
      'Lista usług z podziałem na kategorie (elewacje, wnętrza, remonty generalne)',
      'Obszar działania - konkretnie, jakie miasta i powiaty obsługujecie',
      'Formularz wyceny z polami: co, gdzie, kiedy, zdjęcia',
      'Opinie klientów z imieniem i rodzajem zlecenia',
      'Informacje o doświadczeniu, uprawnieniach i ubezpieczeniu',
      'Klikalny numer telefonu dostępny z każdego miejsca strony',
    ],
  },
  'strona-dla-fotografa': {
    path: '/strona-dla-fotografa',
    h1: 'Strona internetowa dla fotografa',
    metaTitle: 'Strona internetowa dla fotografa | WebNaTak',
    metaDescription:
      'Strona dla fotografa w abonamencie - portfolio, pakiety ślubne, formularz zapytania o termin. Nowoczesny design bez opłat startowych.',
    intro:
      'Strona fotografa to przede wszystkim portfolio. Ale portfolio, które nikt nie zobaczy, jest bezużyteczne. Dlatego nasze strony są zaprojektowane tak, żeby zdjęcia ładowały się szybko, wyglądały dobrze na telefonie i prowadziły oglądającego do formularza zapytania.',
    problem:
      'Wiele stron fotografów robionych jest na platformach w stylu Wix czy Squarespace - ładnie wyglądają, ale są wolne, trudne do zaktualizowania i trudno na nich zamówić zdjęcia.',
    solution:
      'Nasze strony fotografów są szybkie, zoptymalizowane pod galerie i pokazują najważniejsze - Twój styl, pakiety i kontakt. Aktualizację portfolio robimy za Ciebie w ramach abonamentu.',
    features: [
      'Portfolio zdjęć z podziałem na kategorie (śluby, rodzinne, biznes, studyjne)',
      'Strona „O mnie” z Twoim zdjęciem, stylem pracy i doświadczeniem',
      'Opisy pakietów ślubnych / sesyjnych z czasem, liczbą zdjęć i orientacyjną ceną',
      'Formularz zapytania o termin - z polami data, miejsce, budżet',
      'Integracja z Instagramem (feed najnowszych zdjęć)',
      'Szybkie ładowanie galerii nawet przy dużych zdjęciach (WebP, lazy loading)',
      'Opcjonalny blog z historiami ze ślubów - świetnie działa na SEO',
    ],
  },
  'strona-dla-prawnika': {
    path: '/strona-dla-prawnika',
    h1: 'Strona internetowa dla prawnika, adwokata i kancelarii',
    metaTitle: 'Strona internetowa dla prawnika i kancelarii | WebNaTak',
    metaDescription:
      'Strona dla kancelarii prawnej w abonamencie - specjalizacje, zespół, artykuły, kontakt. Profesjonalnie i zgodnie z wymogami branży.',
    intro:
      'Klient szukający prawnika chce wiedzieć, czy trafił do właściwej osoby. Dobrze zaprojektowana strona kancelarii odpowiada na to szybko: jakie sprawy prowadzisz, z jakim doświadczeniem, jak się skontaktować. Cała reszta to już tylko dekoracja.',
    problem:
      'Strony kancelarii w Polsce albo są nieaktualne od lat, albo pełne uogólnień typu „świadczymy kompleksowe usługi prawne”. Klient czyta i dalej nie wie, czy jesteś od rozwodów, czy od spraw karnych.',
    solution:
      'Robimy strony kancelarii z konkretnym opisem specjalizacji, zespołem i sekcją artykułów, która buduje autorytet i przyciąga ruch z Google. Styl spokojny, oficjalny, bez przesady.',
    features: [
      'Lista specjalizacji z opisem typowych spraw w każdej kategorii',
      'Prezentacja zespołu - adwokaci, radcy prawni, aplikanci, doświadczenie',
      'Sekcja artykułów / poradników (świetnie pozycjonuje się w Google)',
      'Informacje o cenniku lub sposobie wyceny sprawy',
      'Formularz kontaktowy z oświadczeniem o poufności i RODO',
      'Mapa dojazdu do kancelarii i informacje o spotkaniu pierwszym',
      'Spokojna kolorystyka i typografia dopasowana do branży prawniczej',
    ],
  },
};

// --- Blog posts ---
export const blogArticles = [
  {
    slug: 'ile-kosztuje-strona-internetowa',
    title: 'Ile kosztuje strona internetowa dla firmy w 2026 roku?',
    excerpt:
      'Konkretne widełki cenowe dla różnych rodzajów stron - od prostej wizytówki do rozbudowanego serwisu z integracjami. Plus: co wpływa na cenę i czego nie widać w ofertach.',
    image:
      'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=600&fit=crop&auto=format',
    imageLarge:
      'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1200&h=800&fit=crop&auto=format',
    author: 'Zespół WebNaTak',
    date: '2026-04-08',
    dateDisplay: '8 kwietnia 2026',
    readTime: '6 min',
    content: [
      {
        type: 'paragraph',
        text: 'Najczęstsze pytanie, jakie dostajemy od klientów, to: „Ile to kosztuje?”. Odpowiedź, niestety, brzmi: „To zależy”. Ale nie zostawimy Cię z tym. W tym artykule pokazujemy konkretne widełki cenowe dla różnych rodzajów stron internetowych i tłumaczymy, co dokładnie wpływa na cenę.',
      },
      { type: 'heading', text: 'Prosta wizytówka - 0–3 000 zł' },
      {
        type: 'paragraph',
        text: 'To strona jednosekcyjna lub kilkupodstronowa, oparta na gotowym szablonie, z podstawowymi tekstami, danymi kontaktowymi i formularzem. Wystarcza małym firmom, które chcą po prostu „być w internecie”.',
      },
      {
        type: 'paragraph',
        text: 'W modelu abonamentowym taka strona kosztuje 0 zł na start i od 199 zł miesięcznie - razem z hostingiem, SSL i wsparciem. W modelu jednorazowym - od 1 500 do 3 000 zł za samą stronę, plus osobno hosting (ok. 300 zł/rok).',
      },
      { type: 'heading', text: 'Strona firmowa z podstronami - 3 000–8 000 zł' },
      {
        type: 'paragraph',
        text: 'Większa strona z kilkoma podstronami (Oferta, O nas, Realizacje, Kontakt, Blog), indywidualnym projektem graficznym, dopasowaną kolorystyką i bardziej rozbudowanymi tekstami. To standard dla firm, które poważnie traktują swoją obecność online.',
      },
      {
        type: 'paragraph',
        text: 'W modelu jednorazowym - od 4 do 8 tysięcy złotych za samą stronę. W abonamencie - 289–379 zł miesięcznie z wszystkim, co potrzebne do działania.',
      },
      { type: 'heading', text: 'Strona z integracjami - 8 000–20 000 zł' },
      {
        type: 'paragraph',
        text: 'Strona, która robi więcej niż tylko prezentuje firmę: rezerwacje online, integracja z CRM, system zapisów, wielojęzyczność, panel klienta. Tu wchodzi programowanie i każdy dodatkowy element podnosi cenę.',
      },
      { type: 'heading', text: 'Sklep internetowy - od 5 000 zł w górę' },
      {
        type: 'paragraph',
        text: 'Sklep to już zupełnie inna kategoria. Podstawowy sklep na WooCommerce z 20–50 produktami, płatnościami online i wysyłką to koszt 5–12 tysięcy złotych. Bardziej rozbudowane rozwiązania (wiele wariantów, hurtowe klientów, integracje z magazynem) potrafią kosztować 20–50 tysięcy.',
      },
      { type: 'heading', text: 'Co wpływa na cenę?' },
      {
        type: 'list',
        title: 'Najważniejsze czynniki:',
        items: [
          'Liczba podstron i ilość unikalnego designu',
          'Czy strona jest na szablonie, czy ma indywidualny projekt',
          'Czy teksty przygotowuje klient, czy firma je pisze',
          'Potrzeba wielojęzyczności',
          'Integracje (CRM, płatności, systemy rezerwacji)',
          'Zakres obsługi po wdrożeniu (aktualizacje, poprawki, SEO)',
        ],
      },
      { type: 'heading', text: 'Czego nie widać w ofertach?' },
      {
        type: 'paragraph',
        text: 'Wielu klientów dowiaduje się po roku, że za aktualizacje, drobne poprawki i problemy trzeba płacić osobno - a stawki są „za godzinę”. Strona, która miała kosztować 5 000 zł, po roku może wyjść 8 000 zł. Dlatego my pracujemy w modelu abonamentowym: wiesz z góry, ile płacisz co miesiąc, i masz wszystko w jednej cenie.',
      },
      { type: 'heading', text: 'Ile powinieneś zapłacić?' },
      {
        type: 'paragraph',
        text: 'Jeśli jesteś małą firmą i potrzebujesz strony, która ma działać, wyglądać dobrze i nie wymagać od Ciebie uwagi - model abonamentowy od 199 zł/mies. to dziś najbardziej opłacalna opcja. Jeśli masz budżet 5–10 tysięcy i chcesz mieć stronę na własność od razu - model jednorazowy też ma sens, ale pamiętaj o późniejszych kosztach.',
      },
      {
        type: 'paragraph',
        text: 'Chcesz porozmawiać o konkretnej cenie dla Twojego przypadku? Napisz do nas - rozmowa jest bezpłatna i bez zobowiązań.',
      },
    ],
  },
  {
    slug: 'strona-w-abonamencie-czy-sie-oplaca',
    title: 'Strona internetowa w abonamencie - czy to się opłaca?',
    excerpt:
      'Porównujemy realny koszt strony w abonamencie z modelem jednorazowym w perspektywie 1, 3 i 5 lat. Plus: kiedy abonament nie ma sensu.',
    image:
      'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=600&fit=crop&auto=format',
    imageLarge:
      'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&h=800&fit=crop&auto=format',
    author: 'Zespół WebNaTak',
    date: '2026-04-05',
    dateDisplay: '5 kwietnia 2026',
    readTime: '5 min',
    content: [
      {
        type: 'paragraph',
        text: 'Model abonamentowy dla stron internetowych zyskuje w Polsce na popularności - ale nie każdy jest do niego przekonany. „Płacić co miesiąc za coś, co już jest zrobione? Lepiej zapłacić raz i mieć spokój”. Brzmi sensownie - aż zaczniesz liczyć.',
      },
      { type: 'heading', text: 'Rok pierwszy - pozornie droższy' },
      {
        type: 'paragraph',
        text: 'Załóżmy, że płacisz 289 zł miesięcznie w abonamencie. Pierwszy rok to 3 468 zł. Za tyle samo lub trochę więcej dostałbyś stronę na własność od freelancera - wydawałoby się, że model jednorazowy wygrywa.',
      },
      {
        type: 'paragraph',
        text: 'Ale to pierwszy rok. Zobaczmy, co się dzieje dalej.',
      },
      { type: 'heading', text: 'Rok drugi - koszty, o których nikt nie mówi' },
      {
        type: 'paragraph',
        text: 'Jeśli masz stronę na własność, za rok musisz zapłacić za hosting (ok. 300–600 zł), certyfikat SSL (0–500 zł), aktualizacje silnika i wtyczek (2–4 godziny pracy rocznie, ok. 300–600 zł), kopie zapasowe (dodatkowa usługa lub Twój czas), drobne poprawki (liczone za godzinę, ok. 150–250 zł/h).',
      },
      {
        type: 'paragraph',
        text: 'Realnie - drugi rok „własnej” strony to 1 500–2 500 zł, jeśli chcesz, żeby działała poprawnie. Jeśli nic nie robisz, strona powoli się starzeje i w pewnym momencie przestanie działać albo zostanie zhakowana.',
      },
      {
        type: 'paragraph',
        text: 'W abonamencie wciąż płacisz 289 zł miesięcznie - wszystko w cenie, nic do robienia.',
      },
      { type: 'heading', text: 'Rok trzeci - kiedy stara strona zaczyna umierać' },
      {
        type: 'paragraph',
        text: 'Po 2–3 latach strony oparte na starszych technologiach zaczynają się „sypać”: pluginy nie są już aktualizowane, biblioteki mają luki bezpieczeństwa, wygląd staje się nie na czasie. Wielu klientów w tym momencie dostaje wycenę na „odświeżenie” - 3–6 tysięcy złotych.',
      },
      {
        type: 'paragraph',
        text: 'W abonamencie odświeżenie jest naturalną częścią usługi - strona jest stale aktualizowana, a co 2–3 lata możemy ją nawet zmienić na nowszy szablon w ramach tej samej kwoty.',
      },
      { type: 'heading', text: 'Porównanie po 5 latach' },
      {
        type: 'list',
        title: 'Koszt 5 lat (realny, z utrzymaniem):',
        items: [
          'Model jednorazowy: 5 000 zł (start) + 5 × 2 000 zł (utrzymanie) = 15 000 zł',
          'Model abonamentowy 289 zł/mies.: 5 × 3 468 zł = 17 340 zł',
        ],
      },
      {
        type: 'paragraph',
        text: 'Różnica to około 2 300 zł - ale w abonamencie przez wszystkie 5 lat masz świeżą, zadbaną stronę z aktualizacjami, kopiami zapasowymi, poprawkami w limicie i wsparciem. W modelu „własnym” - stronę, której realny stan zależy od tego, ile czasu sam jej poświęciłeś.',
      },
      { type: 'heading', text: 'Kiedy abonament NIE ma sensu?' },
      {
        type: 'paragraph',
        text: 'Są sytuacje, kiedy model abonamentowy nie jest najlepszym wyborem:',
      },
      {
        type: 'list',
        items: [
          'Masz własnego programistę lub agencję, która już Cię obsługuje',
          'Potrzebujesz unikalnych funkcjonalności, które wymagają dedykowanego programowania',
          'Chcesz mieć pełną kontrolę nad kodem i hostingiem',
          'Masz budżet 10–20 tysięcy i wolisz inwestycję jednorazową',
        ],
      },
      { type: 'heading', text: 'Dla kogo abonament ma sens?' },
      {
        type: 'paragraph',
        text: 'Dla większości małych i średnich firm, które chcą strony, która działa, wygląda dobrze i nie wymaga od nich technicznej uwagi. Jeśli należysz do tej grupy - prawdopodobnie abonament zaoszczędzi Ci nie tylko pieniądze, ale przede wszystkim nerwy.',
      },
    ],
  },
  {
    slug: 'co-powinna-miec-dobra-strona-firmowa',
    title: 'Co powinna zawierać dobra strona internetowa dla firmy?',
    excerpt:
      'Checklist 12 rzeczy, które powinny znaleźć się na każdej stronie firmowej - od jasnego nagłówka po dane kontaktowe w stopce.',
    image:
      'https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?w=600&h=600&fit=crop&auto=format',
    imageLarge:
      'https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?w=1200&h=800&fit=crop&auto=format',
    author: 'Zespół WebNaTak',
    date: '2026-03-28',
    dateDisplay: '28 marca 2026',
    readTime: '5 min',
    content: [
      {
        type: 'paragraph',
        text: 'Dobra strona firmowa to nie ta, która „wygląda ładnie”. Dobra strona to taka, która odpowiada na pytania klienta w pierwszych 10 sekundach i prowadzi go do kontaktu. Oto 12 rzeczy, bez których żadna strona firmowa nie powinna pójść do sieci.',
      },
      { type: 'heading', text: '1. Jasny nagłówek (H1) z Twoją ofertą' },
      {
        type: 'paragraph',
        text: 'Wchodząc na stronę główną, użytkownik musi w 3 sekundy wiedzieć, czym się zajmujesz i dla kogo. Zamiast „Witaj na naszej stronie” napisz „Tworzymy strony internetowe dla małych firm w Świdnicy”.',
      },
      { type: 'heading', text: '2. Wyraźne wezwanie do akcji (CTA)' },
      {
        type: 'paragraph',
        text: 'Co użytkownik ma zrobić? Zadzwonić? Wypełnić formularz? Umówić spotkanie? Powiedz to wprost, widocznym przyciskiem w kolorze wyróżniającym się od reszty strony.',
      },
      { type: 'heading', text: '3. Sekcja „Dla kogo pracujemy”' },
      {
        type: 'paragraph',
        text: 'Konkretne segmenty klientów. Nie „małe i średnie firmy” - a „salony kosmetyczne, restauracje, gabinety lekarskie, firmy budowlane”. Konkretność buduje wrażenie, że rozumiesz swoją branżę.',
      },
      { type: 'heading', text: '4. Opis usług (konkretnie, nie marketingowo)' },
      {
        type: 'paragraph',
        text: 'Zamiast „kompleksowa obsługa” wypisz, co konkretnie robisz. Im bardziej szczegółowo, tym lepiej. Klient nie kupuje „rozwiązań”, kupuje konkretne rzeczy.',
      },
      { type: 'heading', text: '5. Portfolio lub przykłady realizacji' },
      {
        type: 'paragraph',
        text: 'Zdjęcia, opisy, nazwy klientów (jeśli zgadzają się na publikację). Pokaż, że już to robiłeś.',
      },
      { type: 'heading', text: '6. Opinie klientów' },
      {
        type: 'paragraph',
        text: 'Najlepiej z imieniem, firmą i branżą. Opinie budują zaufanie bardziej niż wszystkie Twoje własne słowa o sobie.',
      },
      { type: 'heading', text: '7. Cennik lub widełki cenowe' },
      {
        type: 'paragraph',
        text: 'Wbrew popularnej opinii, klient woli wiedzieć „od ilu” niż musieć pytać. Jeśli nie chcesz podawać cen, podaj co najmniej „od 199 zł miesięcznie” lub „od 3 000 zł za projekt”.',
      },
      { type: 'heading', text: '8. FAQ - najczęściej zadawane pytania' },
      {
        type: 'paragraph',
        text: 'Jeśli klienci zadają Ci te same pytania 10 razy dziennie, umieść odpowiedzi na stronie. Oszczędzi Ci to czasu i poprawi SEO (Google lubi FAQ).',
      },
      { type: 'heading', text: '9. Dane kontaktowe - widoczne i klikalne' },
      {
        type: 'paragraph',
        text: 'Numer telefonu w nagłówku, e-mail w stopce, formularz na stronie kontakt. Numer telefonu musi być klikalny (tag `tel:`), tak żeby z telefonu można było zadzwonić jednym dotknięciem.',
      },
      { type: 'heading', text: '10. Responsywność (działanie na telefonie)' },
      {
        type: 'paragraph',
        text: 'Ponad 70% ruchu w Polsce to telefony. Strona, która nie działa dobrze na telefonie, jest dziś po prostu bezużyteczna.',
      },
      { type: 'heading', text: '11. Szybkość ładowania' },
      {
        type: 'paragraph',
        text: 'Strona powinna ładować się poniżej 3 sekund. Powyżej - tracisz ponad połowę odwiedzających. Google też tego nie lubi.',
      },
      { type: 'heading', text: '12. Podstawowe SEO' },
      {
        type: 'paragraph',
        text: 'Title, meta description, nagłówki H1/H2, sitemap, robots.txt. Bez tego Google nie będzie umiał Cię znaleźć, nawet jeśli strona jest piękna.',
      },
      { type: 'heading', text: 'Podsumowanie' },
      {
        type: 'paragraph',
        text: 'Dobra strona firmowa to suma konkretów, nie efektów wizualnych. Jeśli Twoja obecna strona nie ma 8 z 12 rzeczy z tej listy - pora na zmianę. My możemy to zrobić za Ciebie w modelu abonamentowym od 199 zł miesięcznie, bez opłat startowych.',
      },
    ],
  },
  {
    slug: 'abonament-czy-jednorazowy-projekt',
    title: 'Abonament czy jednorazowy projekt strony? Porównanie modeli',
    excerpt:
      'Szczegółowe porównanie dwóch najpopularniejszych modeli rozliczania za strony internetowe. Co wybrać dla swojej firmy?',
    image:
      'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=600&h=600&fit=crop&auto=format',
    imageLarge:
      'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1200&h=800&fit=crop&auto=format',
    author: 'Zespół WebNaTak',
    date: '2026-03-20',
    dateDisplay: '20 marca 2026',
    readTime: '5 min',
    content: [
      {
        type: 'paragraph',
        text: 'Decyzja „abonament czy jednorazowy projekt” jest jedną z pierwszych, jakie musisz podjąć, zamawiając stronę internetową. Każdy model ma swoje wady i zalety - w tym artykule pokazujemy oba bez owijania w bawełnę.',
      },
      { type: 'heading', text: 'Model jednorazowy - jak to działa?' },
      {
        type: 'paragraph',
        text: 'Płacisz raz za projekt strony, dostajesz pliki (albo strona jest wdrożona na Twoim serwerze), i strona jest Twoja. Dalsze utrzymanie (hosting, SSL, aktualizacje, poprawki) jest na Twojej głowie - albo dogadujesz się osobno z wykonawcą.',
      },
      {
        type: 'list',
        title: 'Zalety:',
        items: [
          'Wiesz dokładnie, ile zapłacisz - jedna faktura',
          'Strona jest Twoja od pierwszego dnia',
          'Pełna kontrola nad kodem i hostingiem',
          'Możesz w dowolnym momencie zmienić wykonawcę',
        ],
      },
      {
        type: 'list',
        title: 'Wady:',
        items: [
          'Wysoki koszt na start (najczęściej 3–10 tysięcy zł)',
          'Ukryte koszty utrzymania (hosting, SSL, aktualizacje, poprawki)',
          'Brak wsparcia bez dodatkowej umowy',
          'Strona „starzeje się” bez regularnych aktualizacji',
          'Często kończy się „odświeżeniem” po 2–3 latach',
        ],
      },
      { type: 'heading', text: 'Model abonamentowy - jak to działa?' },
      {
        type: 'paragraph',
        text: 'Płacisz stałą kwotę miesięczną (np. 199 zł), a w zamian dostajesz stronę, hosting, SSL, wsparcie, aktualizacje i drobne poprawki w ramach limitu. Nie ma opłaty startowej - wykonawca „zarabia na Tobie” w długim okresie.',
      },
      {
        type: 'list',
        title: 'Zalety:',
        items: [
          'Brak opłaty startowej - startujesz za 0 zł',
          'Wszystko w jednej cenie - bez niespodzianek',
          'Strona zawsze aktualna i zadbana',
          'Szybkie reagowanie na poprawki',
          'Możliwość rezygnacji po okresie minimalnym',
          'Możliwość wykupu strony w dowolnym momencie',
        ],
      },
      {
        type: 'list',
        title: 'Wady:',
        items: [
          'W długim okresie (5+ lat) teoretycznie droższy niż „dobrze utrzymany jednorazowy”',
          'Strona „nie należy do Ciebie” w trakcie trwania abonamentu',
          'Mniej elastyczności w nietypowych integracjach',
        ],
      },
      { type: 'heading', text: 'Który model wybrać?' },
      {
        type: 'paragraph',
        text: 'Ogólna zasada: jeśli jesteś małą firmą i chcesz mieć święty spokój, wybierz abonament. Jeśli masz 5–10 tysięcy do wydania od razu, własnego informatyka i potrzebujesz nietypowych rozwiązań - zainwestuj w model jednorazowy.',
      },
      { type: 'heading', text: 'Najgorszy scenariusz - jednorazowy bez planu utrzymania' },
      {
        type: 'paragraph',
        text: 'Najczęstszy błąd, jaki widzimy: klient płaci 5 000 zł za stronę i myśli, że „ma ją na zawsze”. Po roku coś się psuje, wykonawca już nie odbiera, a strona powoli przestaje działać. W tej sytuacji realny koszt strony jest wyższy niż abonament - bo trzeba ją zrobić od nowa.',
      },
      { type: 'heading', text: 'Nasza rada' },
      {
        type: 'paragraph',
        text: 'Jeśli nie masz pewności, zacznij od abonamentu. Zawsze możesz później wykupić stronę na własność. Trudniej zrobić to w drugą stronę - z „martwej” strony własnej na działający abonament.',
      },
    ],
  },
  {
    slug: 'jak-przygotowac-tresci-na-strone',
    title: 'Jak przygotować teksty na stronę internetową?',
    excerpt:
      'Praktyczny przewodnik po tym, jak napisać teksty, które faktycznie sprzedają - bez marketingowego bełkotu i bez pustych ogólników.',
    image:
      'https://images.unsplash.com/photo-1455390582262-044cdead277a?w=600&h=600&fit=crop&auto=format',
    imageLarge:
      'https://images.unsplash.com/photo-1455390582262-044cdead277a?w=1200&h=800&fit=crop&auto=format',
    author: 'Zespół WebNaTak',
    date: '2026-03-12',
    dateDisplay: '12 marca 2026',
    readTime: '5 min',
    content: [
      {
        type: 'paragraph',
        text: 'Najwięcej problemów w projektach stron internetowych robią nie kolory ani typografia, ale teksty. Klienci często tygodniami „nie mają czasu” napisać opisów, a kiedy w końcu przysyłają - są to ogólnikowe akapity, które nikogo nie przekonują. Oto jak to zrobić dobrze.',
      },
      { type: 'heading', text: '1. Zacznij od klienta, nie od siebie' },
      {
        type: 'paragraph',
        text: 'Najczęstszy błąd: teksty zaczynają się od „Jesteśmy firmą z 20-letnim doświadczeniem...”. Klienta nie obchodzi Twoje doświadczenie - obchodzi go jego problem. Zacznij od jego punktu widzenia: „Szukasz szybkiego elektryka w Świdnicy? Przyjedziemy w ten sam dzień.”',
      },
      { type: 'heading', text: '2. Konkrety zamiast ogólników' },
      {
        type: 'paragraph',
        text: 'Zamiast „kompleksowa obsługa” napisz, co dokładnie robisz. Zamiast „wysokie standardy” napisz, jak mierzysz jakość. Każde zdanie, które nic nie znaczy, jest zdaniem do wyrzucenia.',
      },
      { type: 'heading', text: '3. Krótkie akapity' },
      {
        type: 'paragraph',
        text: 'Internet to nie książka. Ludzie skanują teksty wzrokiem, nie czytają linijka po linijce. Twój akapit powinien mieć 2–4 zdania, maks. 5. Długie bloki tekstu nikogo nie przekonają.',
      },
      { type: 'heading', text: '4. Używaj „Ty” zamiast „Państwo”' },
      {
        type: 'paragraph',
        text: 'Chyba że prowadzisz kancelarię adwokacką, zwróć się do klienta bezpośrednio - „Ty” albo „Twoja firma”. To buduje bliskość i skraca dystans.',
      },
      { type: 'heading', text: '5. Odpowiadaj na pytania' },
      {
        type: 'paragraph',
        text: 'Zapisz listę pytań, które najczęściej dostajesz od klientów (ile kosztuje, jak długo trwa, co w cenie, co bez). Każde pytanie = potencjalny akapit lub podstrona.',
      },
      { type: 'heading', text: '6. Dodaj konkretne liczby' },
      {
        type: 'paragraph',
        text: '„Ponad 100 zrealizowanych projektów”, „7 dni od zamówienia do publikacji”, „15 lat doświadczenia”. Liczby są konkretne i zapamiętywane lepiej niż przymiotniki.',
      },
      { type: 'heading', text: '7. Wyrzuć puste słowa' },
      {
        type: 'paragraph',
        text: 'Lista słów do unikania: „innowacyjny”, „profesjonalny” (jeśli bez dowodu), „kompleksowy”, „dedykowany”, „zorientowany na klienta”, „synergia”. Wszystkie są tak oklepane, że przestały coś znaczyć.',
      },
      { type: 'heading', text: '8. Zakończ wezwaniem do akcji' },
      {
        type: 'paragraph',
        text: 'Każdy dłuższy blok tekstu powinien kończyć się jasnym CTA. Może to być „Zadzwoń teraz”, „Wypełnij formularz”, „Umów darmową konsultację”. Bez tego czytelnik przeczyta, skinie głową i zamknie kartę.',
      },
      { type: 'heading', text: 'Nie masz czasu? Możemy napisać za Ciebie' },
      {
        type: 'paragraph',
        text: 'W WebNaTak oferujemy napisanie tekstów od zera - na podstawie rozmowy z Tobą. Przygotowujemy propozycję, Ty zatwierdzasz. To usługa dodatkowa, poza standardowym abonamentem - ale często najlepsza inwestycja, jaką możesz zrobić w swoją stronę.',
      },
    ],
  },
  {
    slug: 'najczestsze-bledy-na-stronach-firm',
    title: '7 najczęstszych błędów na stronach małych firm',
    excerpt:
      'Co najczęściej psuje strony firmowe i jak to naprawić - od braku klikalnego telefonu po automatycznie odtwarzające się filmy.',
    image:
      'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=600&h=600&fit=crop&auto=format',
    imageLarge:
      'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=1200&h=800&fit=crop&auto=format',
    author: 'Zespół WebNaTak',
    date: '2026-03-05',
    dateDisplay: '5 marca 2026',
    readTime: '6 min',
    content: [
      {
        type: 'paragraph',
        text: 'Przy audytach stron małych firm, które robimy, te same błędy pojawiają się po wielokroć. Niektóre z nich są banalne do naprawy, inne wymagają przebudowy całej strony. Oto siódemka najgorszych.',
      },
      { type: 'heading', text: '1. Brak klikalnego numeru telefonu' },
      {
        type: 'paragraph',
        text: 'Klient ogląda stronę na telefonie, chce zadzwonić, klika w numer... i nic. Bo wykonawca zapomniał dodać tag `tel:`. Rezultat: klient ręcznie przepisuje numer albo (częściej) dzwoni do konkurencji.',
      },
      {
        type: 'paragraph',
        text: 'Naprawa: 2 minuty pracy. Zamiast tekstu napisz `<a href="tel:+48573195600">+48 573 195 600</a>`.',
      },
      { type: 'heading', text: '2. Formularz kontaktowy, który nie działa' },
      {
        type: 'paragraph',
        text: 'Strona ma formularz, ale wiadomości wysyłane z niego nigdzie nie docierają. Klient wypełnia, klika „Wyślij”, dostaje „Dziękujemy” - i nikt nigdy tego nie widzi. Sprawdź SWÓJ formularz raz na tydzień, wysyłając testową wiadomość.',
      },
      { type: 'heading', text: '3. Strona wolna na telefonie' },
      {
        type: 'paragraph',
        text: 'Ogromne zdjęcia w pełnej rozdzielczości, ładujące się filmy, setki skryptów analitycznych. Strona na szybkim łączu działa, na słabym (w centrum miasta, w pociągu) się zawiesza. 70% potencjalnych klientów już jej nie zobaczy.',
      },
      {
        type: 'paragraph',
        text: 'Naprawa: WebP zamiast JPG, lazy loading, minifikacja kodu, cache. To standard, o który dbamy przy każdej stronie.',
      },
      { type: 'heading', text: '4. Automatycznie odtwarzające się filmy z dźwiękiem' },
      {
        type: 'paragraph',
        text: 'Klient otwiera stronę w pracy, z kolegami obok, i nagle z głośników leci muzyka z tła wideo. Zamyka stronę natychmiast. Nigdy nie wraca.',
      },
      { type: 'heading', text: '5. Brak aktualnych danych' },
      {
        type: 'paragraph',
        text: '„Aktualna promocja” z 2019 roku, godziny otwarcia sprzed pandemii, cennik, który już nie obowiązuje. Klient się orientuje i traci zaufanie. Uaktualnianie strony to praca, którą trzeba robić regularnie - dlatego warto mieć kogoś, kto to robi za Ciebie.',
      },
      { type: 'heading', text: '6. Popupy zaraz po wejściu' },
      {
        type: 'paragraph',
        text: '„Zapisz się do newslettera!” - natychmiast po otwarciu strony, zanim klient w ogóle zobaczy, czym się zajmujesz. To jak wrzucanie ulotki w twarz komuś, kto dopiero wszedł do sklepu.',
      },
      {
        type: 'paragraph',
        text: 'Jeśli używasz popupów, opóźniaj je o co najmniej 15 sekund lub pokazuj przy próbie wyjścia ze strony.',
      },
      { type: 'heading', text: '7. Błędy ortograficzne i literówki' },
      {
        type: 'paragraph',
        text: 'Nic tak szybko nie psuje wiarygodności, jak literówki i błędy ortograficzne na stronie. Świadczą o tym, że nikt tego nie przeczytał po napisaniu. Jeśli nie jesteś pewien swoich tekstów - poproś kogoś o sprawdzenie. Albo skorzystaj z narzędzi typu LanguageTool.',
      },
      { type: 'heading', text: 'Sprawdź swoją stronę' },
      {
        type: 'paragraph',
        text: 'Otwórz swoją stronę w trybie prywatnym przeglądarki, na telefonie, przy słabym zasięgu. Sprawdź, czy numer jest klikalny, czy formularz działa, czy nic nie leci z dźwiękiem, czy dane są aktualne. To 10 minut, które mogą zaoszczędzić Ci utraconych klientów.',
      },
      {
        type: 'paragraph',
        text: 'A jeśli nie masz na to ochoty - my robimy takie audyty dla klientów, którzy chcą przejść na nasz abonament. Bezpłatnie, bez zobowiązań.',
      },
    ],
  },
];
